import { render } from "./Nav.vue?vue&type=template&id=737e693e&scoped=true&ts=true"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=737e693e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/miki-ihara-law-and-patent-office/miki-ihara-law-and-patent-office/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737e693e"]])

export default __exports__